import { render, staticRenderFns } from "./rewardChooseOneEdit.vue?vue&type=template&id=066ab698&scoped=true&"
import script from "./rewardChooseOneEdit.vue?vue&type=script&lang=js&"
export * from "./rewardChooseOneEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066ab698",
  null
  
)

export default component.exports